import { Form, Select } from "../../../../../../../../shared/frontend/ui";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../app/auth/useAuth";
import { useI18n } from "../../../../app/i18n/useI18n";
import { useUiPreferences } from "../../../../app/prefs/useUiPreferences";
import { DATE_TIME_2DIGIT_OPTS, formatDateTimeIso } from "../../../../app/units/format";
import type { ImportAdapterCreateFieldsProps } from "../importAdapterRegistry";
import type { IcmPersonRunOption } from "./icmImportApi";
import { useFeedback } from "../../../../../../../../shared/frontend/feedback/useFeedback";

/** Anlegefelder des ICM-Adapters: der abgeschlossene CenterCom-Personenlauf desselben Mandanten. */
export function IcmCreateRunFields({ tenantId }: ImportAdapterCreateFieldsProps) {
  const { text } = useI18n();
  const feedback = useFeedback();
  const auth = useAuth();
  const ui = useUiPreferences();
  const units = ui.prefs?.units;
  const [personRunLoad, setPersonRunLoad] = useState<{ tenantId: string; items: IcmPersonRunOption[]; error: boolean } | null>(null);

  useEffect(() => {
    if (!tenantId) return;
    let cancelled = false;
    auth.api.get<IcmPersonRunOption[]>(`/api/v1/admin/import-adapters/icm/person-runs?tenantId=${encodeURIComponent(tenantId)}`).then((list) => {
      if (!cancelled) setPersonRunLoad({ tenantId, items: Array.isArray(list) ? list : [], error: false });
    }).catch(() => {
      if (!cancelled) {
        setPersonRunLoad({ tenantId, items: [], error: true });
        feedback.error(text("ICM import person run load error"));
      }
    });
    return () => {
      cancelled = true;
    };
  }, [auth.api, feedback, tenantId, text]);

  const loadForSelection = tenantId && personRunLoad?.tenantId === tenantId ? personRunLoad : null;
  const personRuns = loadForSelection && !loadForSelection.error ? loadForSelection.items : [];
  const personRunsEmpty = loadForSelection != null && !loadForSelection.error && loadForSelection.items.length === 0;

  return (
    <Form.Item
      label={text("ICM import person run")}
      name="centerComImportRunId"
      extra={personRunsEmpty ? text("ICM import person run empty") : text("ICM import person run hint")}
      rules={[{ required: true, message: text("ICM import person run required") }]}
    >
      <Select
        placeholder={text("ICM import person run placeholder")}
        notFoundContent={text("ICM import person run empty short")}
        options={personRuns.map((run) => ({
          label: `${run.displayName?.trim() || run.id} · ${formatDateTimeIso(run.updatedAt, units, DATE_TIME_2DIGIT_OPTS)} · ${text(`CenterCom import mode ${run.importMode}`)}`,
          value: run.id
        }))}
        showSearch
        optionFilterProp="label"
        disabled={personRunsEmpty}
      />
    </Form.Item>
  );
}
